import React, { useEffect, useRef } from "react";
import { useField } from "@unform/core";
import ErrorMessage from "./ErrorMessage";
import FormRow from "./FormRow";
import Label from "./Label";

const Input = ({
  type = "text",
  id,
  name,
  label = null,
  placeholder = "",
  defaultValue = "",
  ...rest
}) => {
  const inputRef = useRef(null);
  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => {
        return ref.current.value;
      },
      setValue: (ref, value) => {
        ref.current.value = value;
      },
      clearValue: (ref) => {
        ref.current.value = "";
      },
    });
  }, [fieldName, registerField]);

  return (
    <div className="input-wrapper">
      {label && <Label htmlFor={id}>{label}</Label>}
      <FormRow>
        <input
          type={type}
          id={id}
          name={name}
          ref={inputRef}
          className={error ? "error" : ""}
          placeholder={placeholder}
          // defaultValue={defaultValue}
          {...rest}
        />
      </FormRow>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

export default Input;
